import constraintsStore from 'shared/store/constraintsStore';
import { Input } from 'shared/components/ui/input';
import colorsStore from 'shared/store/colorsStore';

type LiquidityContentProps = {
  configData: {
    amount: { default: number; label: string; ge: number; type: string };
    withdraw: { default: boolean; label: string; type: string };
  };
};

export function LiquidityContent({ configData }: LiquidityContentProps) {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  const liquidity = constraintsStore((s) => s.workingDocument?.liquidity);

  // Distinguish "unset" (null/undefined → empty input) from "zero" (typed
  // 0 → stored as 0). Falling back to `configData.amount.default ?? 0`
  // for display made the input always show a 0 that came right back on
  // every clear attempt — the user could never delete it.
  const amountRaw = liquidity?.amount as number | null | undefined;
  const amountDisplay = amountRaw == null ? '' : amountRaw;
  const withdraw = (liquidity?.withdraw as boolean | undefined) ?? configData?.withdraw?.default ?? false;

  const handleInputChange = (e: any) => {
    const fieldId = e.target.id;
    if (fieldId !== 'amount') return;
    const text = e.target.value;
    if (text === '') {
      // Empty input clears the constraint; do NOT write 0 here, that's
      // a real value (zero apporto/prelievo) and the user couldn't
      // distinguish it from "unset".
      constraintsStore.getState().applyGroupEdits('liquidity', { amount: null });
      return;
    }
    const parsedValue = parseFloat(text);
    if (Number.isNaN(parsedValue)) return;
    constraintsStore.getState().applyGroupEdits('liquidity', {
      amount: Math.max(0, parsedValue),
    });
  };

  const handleOperationTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const isWithdrawal = e.target.value === 'prelievo';
    constraintsStore.getState().applyGroupEdits('liquidity', { withdraw: isWithdrawal });
  };

  return (
    <div style={{ marginTop: 0, color: colorsConfig.finecoBlack, fontSize: 14 }}>
      <div style={{ marginTop: 24, display: 'flex', gap: 16 }}>
        <div style={{ flex: 1 }}>
          <select
            value={withdraw ? 'prelievo' : 'deposito'}
            onChange={handleOperationTypeChange}
            className="w-full rounded border p-2"
            style={{ borderColor: colorsConfig.gray2 }}
          >
            <option value="deposito">Apporto</option>
            <option value="prelievo">Prelievo</option>
          </select>
        </div>
        <div style={{ flex: 1 }}>
          <Input
            id="amount"
            type="number"
            value={amountDisplay}
            onChange={handleInputChange}
            min={configData?.amount?.ge ?? 0}
            className="w-full"
            style={{ borderColor: colorsConfig.gray2 }}
          />
        </div>
      </div>
    </div>
  );
}
